








































































import { CustomerLevel } from '@/api/api';
import OrdinaryPriceTab from '@/components/prices/OrdinaryPriceTab.vue';
import {
  BTable,
  BTh,
  BTd,
  BTr,
  BTfoot,
  BThead,
  BTbody,
  BFormInput,
  BButton,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BContainer,
  BRow,
  BCol,
  BDropdownDivider,
  BCard,
  BCardHeader,
  BCardBody,
  BCardText,
  BCollapse
} from 'bootstrap-vue';
import Vue from 'vue';
import Component from 'vue-class-component';
import { VueGoodTable } from 'vue-good-table';
import Pagination from '@/@core/components/paginations/Pagination.vue';
import PriceAreaFormModal from '@/components/prices/PriceAreaFormModal.vue';
import VipPriceTab from '@/components/prices/VipPriceTab.vue';
import PaperPriceTab from '@/components/prices/paper/PaperPriceTab.vue';
import StandeePriceTab from '@/components/prices/standee/StandeePriceTab.vue';
import CataloguePriceTab from '@/components/prices/catalogue/CataloguePriceTab.vue';

// Define the component in class-style
@Component({
  components: {
    BTable,
    BTh,
    BTd,
    BTr,
    BTfoot,
    BThead,
    BTbody,
    BFormInput,
    BButton,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BContainer,
    BRow,
    BCol,
    BDropdownDivider,
    BCard,
    BCardHeader,
    BCardBody,
    BCardText,
    BCollapse,
    OrdinaryPriceTab,
    VipPriceTab,
    Pagination,
    PriceAreaFormModal,
    VueGoodTable,
    PaperPriceTab,
    StandeePriceTab,
    CataloguePriceTab
  }
})
export default class StickerPrice extends Vue {
  CustomerLevel = CustomerLevel;
}
